import { Box } from '@mui/material'
import type { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const FloatingFooter: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        bgcolor: 'background.paper',
        p: 2,
        borderTop: 1,
        borderColor: 'divider',
        display: 'flex',
        gap: 1,
        justifyContent: 'flex-end',
      }}
    >
      {children}
    </Box>
  )
}
